import React, { Component } from "react";
import ListPengalaman from "./ListPengalaman";

class Pengalaman extends Component {
    render() {
        return (
            <ListPengalaman />
        );
    }
}

export default Pengalaman;
